import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { BadgeOptions } from 'src/registry/types/badges';
import { Badge } from 'src/registry/ui/Badge';
import { generalMessages } from 'src/registry/utils/messages';

type PricingPlanBadgeProps = {
    badgeOptions: BadgeOptions;
    badgeIndexKey?: string;
};

const PricingPlanBadge = ({ badgeOptions, badgeIndexKey }: PricingPlanBadgeProps) => {
    const { formatMessage } = useIntl();

    if (!badgeIndexKey || !badgeOptions[badgeIndexKey]) return '-';
    return (
        <Badge theme={badgeOptions[badgeIndexKey]?.theme || 'gray'}>
            {badgeOptions[badgeIndexKey]?.icon && <FontAwesomeIcon icon={badgeOptions[badgeIndexKey].icon} />}
            {badgeOptions[badgeIndexKey]?.label
                ? formatMessage(badgeOptions[badgeIndexKey]?.label)
                : formatMessage(generalMessages.noValue)}
        </Badge>
    );
};

export default PricingPlanBadge;
